module.exports = {"510322001":"富世街道","510322002":"邓井关街道","510322003":"东湖街道","510322102":"琵琶镇","510322103":"狮市镇","510322104":"骑龙镇","510322111":"代寺镇","510322113":"童寺镇","510322114":"古佛镇","510322115":"永年镇","510322117":"兜山镇","510322118":"板桥镇","510322119":"福善镇","510322120":"李桥镇","510322121":"赵化镇","510322122":"安溪镇","510322124":"飞龙镇","510322125":"怀德镇","510322126":"长滩镇","510322200":"龙万乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510322.json
// module id = 2410
// module chunks = 0